<template>
    <div class="drop-menu">
        <v-popover placement="right"
                   popoverArrowClass="v-tooltip-arrow"
                   popoverBaseClass="v-tooltip v-popover"
                   offset="20"
                   :open="open"
                   trigger="manual"
                   :auto-hide="false">
            <slot name="trigger"></slot>
            <template slot="popover" class="p-6">
                <w-close-icon class="close-icon" @click="$emit('close')" v-close-popover></w-close-icon>
                <slot name="content" class="pt-5"></slot>
            </template>
        </v-popover>
    </div>
</template>

<script>
export default {
    name: 'DropDownMenu',
    props: ['open']
}
</script>

<style>
    .popover-inner {
        background: #fff !important;
        color: #a1a1a1 !important;
        padding: 35px 24px !important;
        border-radius: 5px !important;
        border: 1px solid #ccc !important;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19) !important;
    }

    .v-tooltip {
        z-index: 1 !important;
    }

    .v-popover > span {
        width: 100%;
    }

    @media (max-width: 576px) {
        .v-tooltip {
            position: fixed !important;
            top: 50% !important;
            left: 50% !important;
            margin-left: -150px;
            transform: translateY(-50%) !important;
        }
    }

    .tooltip-inner {
        max-width: 300px !important;
    }

    .line-label {
        height: 18px;
        position: relative;
    }

    .line-label > span {
        cursor: pointer;
        position: absolute;
        bottom: 0;
    }

    .line-label .left {
        left: 0;
    }

    .line-label .right {
        right: 0;
    }

    .close-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>
